import { execToast } from "../../App";

const Notification = (props) => {
  execToast(props);
};

export default Notification;
